import { Hint } from "@iec-id/ui";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface StepTitleProps {
	children: ReactNode;
	tooltip?: ReactNode;
}

/** Заголовок шага: 24px/1.2, трекинг −0.02em — роль `t-section`. */
export function StepTitle({ children, tooltip }: StepTitleProps) {
	// Подпись самой кнопки-вопроса: кит текстовых дефолтов не держит (Д11), а
	// скринридер объявляет именно её, а не текст подсказки.
	const { t } = useTranslation("common");
	if (!tooltip) return <h1 className="t-section text-fg">{children}</h1>;
	return (
		<div className="flex items-center gap-2">
			<h1 className="t-section text-fg">{children}</h1>
			{/* Тот же сдвиг, что у заголовков карточек витрины (`SectionCard`):
			    знак стоит по середине строчных букв, а не заглавных. */}
			<Hint label={tooltip} triggerLabel={t("action.hint")} className="mt-[0.1em]" />
		</div>
	);
}
